import { Badge, Button, Col, Placeholder, Row, Spinner, Table } from "react-bootstrap";

export function ImportProcessResult({
  processResult,
  loading,
  exportingBatchId,
  handleExportBatchDetails
}) {
  const processedCount = Number(processResult?.success ?? 0) + Number(processResult?.alert ?? 0);

  return (
    <>
      {(processResult && !loading.isLoading) && (
        <>
          <Col>
            <h6>{processResult.file}</h6>
            <p>Data: {processResult.processDate}</p>
            <p>Lote: {processResult.id_lote}</p>
          </Col>
          <Col>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td className="text-center">
                    <h6>
                      <Badge bg="success" className="p-1">Processados: {processedCount}</Badge>
                    </h6>
                  </td>
                  <td className="text-center">
                    <h6>
                      <Badge bg="yellow" className="p-1">Alertas: {processResult.alert}</Badge>
                    </h6>
                  </td>
                  <td className="text-center">
                    <h6>
                      <Badge bg="orange" className="p-1">Não processados: {processResult.no_processed}</Badge>
                    </h6>
                  </td>
                  <td className="text-center">
                    <h6>
                      <Badge bg="danger" className="p-1">Erros: {processResult.error}</Badge>
                    </h6>
                  </td>
                  <td>
                    <Row className="justify-content-center">
                      <Button
                        type="button"
                        variant="info"
                        size="sm"
                        className="float-end"
                        disabled={exportingBatchId !== null}
                        onClick={() => handleExportBatchDetails(processResult.id_lote)}
                      >
                        {exportingBatchId === processResult.idlote ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              className="me-2"
                            /> {" "}
                            Exportando...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-file-export mr-2" />
                            Exportar
                          </>
                        )}
                      </Button>
                    </Row>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </>
      )}

      {(!processResult && loading.isLoading) && (
        <Row className="mt-2">
          <Row className="w-100">
            <Col sm={6}>
              <Placeholder as="p" animation="glow" className="w-100">
                <Placeholder sm={6} className="w-100 rounded" />
              </Placeholder>
              <Placeholder as="p" animation="glow" className="w-100">
                <Placeholder sm={6} className="w-100 rounded" />
              </Placeholder>
              <Placeholder as="p" animation="glow" className="w-100">
                <Placeholder sm={6} className="w-100 rounded" />
              </Placeholder>
            </Col>
          </Row>
          <Row className="w-100 mt-4">
            <Col>
              <Placeholder as="p" animation="glow" className="w-100 text-center">
                <Placeholder xs={6} className="w-100 rounded" />
              </Placeholder>
            </Col>
            <Col>
              <Placeholder as="p" animation="glow" className="w-100 text-center">
                <Placeholder xs={6} className="w-100 rounded" />
              </Placeholder>
            </Col>
            <Col>
              <Placeholder as="p" animation="glow" className="w-100 text-center">
                <Placeholder xs={6} className="w-100 rounded" />
              </Placeholder>
            </Col>
            <Col>
              <Placeholder as="p" animation="glow" className="w-100 text-center">
                <Placeholder xs={6} className="w-100 rounded" />
              </Placeholder>
            </Col>
            <Col>
              <Placeholder as="p" animation="glow" className="w-100 text-center">
                <Placeholder xs={6} className="w-100 rounded" />
              </Placeholder>
            </Col>
          </Row>
        </Row>
      )}

      {(!processResult && !loading.isLoading) && (
        <p className="text-muted text-center">
          Nenhum processamento realizado.
        </p>
      )}
    </>
  )
}
